import "./DashboardNotificationSettingsComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IRootElementService, IScope} from "angular";
import {UserNotificationPreferencesDialogService} from "../../../../notifications/services/preferences-dialog/UserNotificationPreferencesDialogService";
import {UserNotificationPreferencesService} from "../../../../notifications/services/preferences/UserNotificationPreferencesService";
import {ReplaySubject} from "rxjs";
import {UserNotificationPreferences} from "../../../../notifications/services/preferences/preferences/UserNotificationPreferences";
import {MessageType} from "../../../../notifications/services/preferences/models/MessageType";
import {NotificationState} from "../../../../notifications/services/preferences/models/NotificationState";

export const DashboardNotifications = "tfDashboardNotifications";

export function dashboardNotifications(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/notifications/DashboardNotificationSettingsComponent.html`,
        controllerAs: "ctrl",
        controller: DashboardNotificationSettingsComponentController
    };
}

export class DashboardNotificationSettingsComponentController implements IOnInit, IOnDestroy {

    public priceAlertsActive = false;
    public orderFillsActive = false;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $scope: IScope,
                       private readonly $element: IRootElementService,
                       private readonly userNotificationPreferencesService: UserNotificationPreferencesService,
                       private readonly userNotificationPreferencesDialogService: UserNotificationPreferencesDialogService) {
    }

    public $onInit(): void {
        this.userNotificationPreferencesService
            .preferences
            .takeUntil(this.destroyed$)
            .subscribe((preferences) => this.preferencesChanged(preferences));
    }

    private preferencesChanged(preferences: UserNotificationPreferences) {
        const orderState = preferences.state(MessageType.ORDER_FILLED);
        const tradingAlertState = preferences.state(MessageType.TRADING_ALERT);
        this.$scope.$applyAsync(() => {
            this.priceAlertsActive = tradingAlertState === NotificationState.ACTIVE;
            this.orderFillsActive = orderState === NotificationState.ACTIVE;
            if (this.priceAlertsActive && this.orderFillsActive) {
                this.$element.addClass("hidden");
            } else {
                this.$element.removeClass("hidden");
            }
        });
    }

    public configureNotifications() {
        this.userNotificationPreferencesDialogService.open();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
